// import hmscApiService from "./hmscApiService";
// import {API} from "../constants"

// const CACHE_DURATION_MS = 5 * 60 * 1000; // 5 minutes
// let cachedLanguages = null;
// let lastFetchedTime = 0;

// const languageService = {
//   fetchLanguages: async () => {
//     const now = Date.now();
//     if (cachedLanguages && now - lastFetchedTime < CACHE_DURATION_MS) {
//       return cachedLanguages;
//     } 
//     const response = await hmscApiService.get(API.LANGUAGE_GET_LIST);
//     cachedLanguages = response.data.data;
//     lastFetchedTime = now;

//     return cachedLanguages;
//   },
// };

// export default languageService;


import { useDispatch, useSelector } from "react-redux";
import { cacheApiRequest } from "../utils/cacheApiRequest";
import { clearCache, clearAllCacheForBaseKey } from "../store/cacheSlice";

export const useLanguageService = () => {
  const dispatch = useDispatch();
  const cache = useSelector(state => state.cache.cache);

  const fetchLanguages = async (params = {}, forceRefresh = false) => {
    const key = "LANGUAGE_GET_LIST";
    if (forceRefresh) {
      dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  return { fetchLanguages };
};

 

